<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_ii"></a><a id="page_iii"></a>Combat Reporter</h1>
<p class="bsubtitle"><span class="small">DON WHITEHEAD’S WORLD WAR II DIARY AND MEMOIRS</span></p>
<p class="author"><em>Edited by John B. Romeiser</em></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3d5614b7